// 사운드 — 미니멀. 달빛 무드라 배경음악·팡파레 없음. Web Audio 합성(에셋 무의존).
// 토글: 설정 소리 on/off. 기본 on.

const KEY = "hyuh_sound";

export function soundEnabled(): boolean {
  return localStorage.getItem(KEY) !== "off";
}
export function setSoundEnabled(on: boolean): void {
  localStorage.setItem(KEY, on ? "on" : "off");
}

let ctx: AudioContext | null = null;
function ac(): AudioContext | null {
  if (typeof window === "undefined") return null;
  const Ctor = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return null;
  if (!ctx) ctx = new Ctor();
  if (ctx.state === "suspended") void ctx.resume();
  return ctx;
}

/** 사용자 제스처(제출 탭) 때 오디오 컨텍스트를 미리 깨워둔다 → 직후 재생 지연 제거. */
export function warmupSound(): void {
  ac();
}

/** 마이크 켜고 끌 때 작은 칩(부드러운 사인). */
export function playChirp(up = true): void {
  if (!soundEnabled()) return;
  const c = ac();
  if (!c) return;
  const t0 = c.currentTime;
  const osc = c.createOscillator();
  osc.type = "sine";
  osc.frequency.setValueAtTime(up ? 540 : 420, t0);
  osc.frequency.exponentialRampToValueAtTime(up ? 760 : 320, t0 + 0.09);
  const g = c.createGain();
  g.gain.setValueAtTime(0.0001, t0);
  g.gain.exponentialRampToValueAtTime(0.09, t0 + 0.012);
  g.gain.exponentialRampToValueAtTime(0.0001, t0 + 0.16);
  osc.connect(g).connect(c.destination);
  osc.start(t0);
  osc.stop(t0 + 0.18);
}

/** 편지 강림 — 낮고 따뜻한 더블 톤(달이 차오르는 듯). 환호 아님. */
export function playRise(): void {
  if (!soundEnabled()) return;
  const c = ac();
  if (!c) return;
  const t0 = c.currentTime;
  [196, 294].forEach((f, i) => {
    const osc = c.createOscillator();
    osc.type = "sine";
    osc.frequency.setValueAtTime(f, t0 + i * 0.18);
    const g = c.createGain();
    g.gain.setValueAtTime(0.0001, t0 + i * 0.18);
    g.gain.exponentialRampToValueAtTime(0.06, t0 + i * 0.18 + 0.08);
    g.gain.exponentialRampToValueAtTime(0.0001, t0 + i * 0.18 + 1.1);
    osc.connect(g).connect(c.destination);
    osc.start(t0 + i * 0.18);
    osc.stop(t0 + i * 0.18 + 1.2);
  });
}
